import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import AboutContent from './components/AboutContent';
import AgencyPrinciple from './components/AgencyPrinciple';
import Values from './components/Values';
import AgencyMission from './components/AgencyMission';

export default function About() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <AboutHero />
      <AboutContent />
      <AgencyPrinciple />
      <Values />
      <AgencyMission />
      <Footer />
    </div>
  );
}